






























































import Vue from "vue";
import ApiSearch from "@/components/apiSearch/components/ApiSearchPage.vue";
import MoneyDisplay from "@/components/MoneyDisplay.vue";
import PreAccItemDims from "./PreAccItemDims.vue";
import { t } from "@/plugins/i18n";

interface Data {
  url: string;
}

type PreAccInvoice = any;

export default Vue.extend<Data, {}, {}, {}>({
  props: {
    invoice: { type: Object as () => PreAccInvoice },
    // Könyvelési típus szűrő a képernyő szűrőpaneljéről (K2D: a tétel-listát szűri)
    bookTypes: { type: Array as () => number[], default: () => [] },
  },

  components: {
    ApiSearch,
    MoneyDisplay,
    PreAccItemDims,
  },

  data() {
    return {
      url: "",
    };
  },

  beforeMount() {
    const invoice = this.$props.invoice;
    const bookTypes: number[] = this.$props.bookTypes ?? [];
    const query = bookTypes.length > 0 ? `?bookTypes=${bookTypes.join(",")}` : "";
    this.url = `pre-accounting-invoices/${invoice.code}/${invoice.id}/items${query}`;
  },

  computed: {
    // Az ApiSearchPage modell-építéséhez (szűrő nincs a tétel-oszlopokon)
    columns: () => [
      { field: "accCode", title: t("FokonyviSzam"), filterable: false },
      { field: "accName", title: t("PreAccounting_FokonyviSzamNeve"), filterable: false },
      { field: "mainTypeName", title: t("PreAccounting_FokonyviTeteltipus"), filterable: false },
      { field: "accSign", title: t("Transactions_TartozikKovetel"), filterable: false },
      { field: "total", title: t("Osszeg"), filterable: false },
      { field: "currency", title: t("Penznem"), filterable: false },
      { field: "accDate", title: t("KonyvelesDatuma"), filterable: false },
      { field: "dimTypeName", title: t("PreAccounting_KonyvelesiTipus"), filterable: false },
      { field: "dimCode1", title: t("Dim1"), filterable: false },
      { field: "dimCode2", title: t("GeneralLedger_Dim2"), filterable: false },
      { field: "dimCode3", title: t("GeneralLedger_Dim3"), filterable: false },
      { field: "note", title: t("Megjegyzes"), filterable: false },
    ],

    kendoColumns: () => [
      { field: "showDims", title: " ", cell: "commandTemplate", filterable: false, sortable: false, width: "56px" },
      { field: "accCode", title: t("FokonyviSzam") },
      { field: "accName", title: t("PreAccounting_FokonyviSzamNeve") },
      { field: "mainTypeName", title: t("PreAccounting_FokonyviTeteltipus") },
      { field: "accSign", title: t("Transactions_TartozikKovetel"), cell: "accSignTemplate" },
      { field: "total", title: t("Osszeg"), cell: "totalTemplate", width: "130px" },
      { field: "currency", title: t("Penznem") },
      { field: "accDate", title: t("KonyvelesDatuma"), width: "130px" },
      { field: "dimTypeName", title: t("PreAccounting_KonyvelesiTipus"), width: "140px" },
      { field: "dimCode1", title: t("Dim1") },
      { field: "dimCode2", title: t("GeneralLedger_Dim2") },
      { field: "dimCode3", title: t("GeneralLedger_Dim3") },
      { field: "note", title: t("Megjegyzes"), width: "200px" },
      { filterable: false, sortable: false, width: 0 },
    ],

  },
});
